export default __webpack_public_path__ + "static/media/6.e9b603a8.jpg";